import { claimFreePackage } from "@/API/offers";

export const chainClaim = {
  data() {
    return {
      claiming: false,
    };
  },
  methods: {
    // Claim a free (zero-price) package: claim → play the full reward-earned
    // animation (same as other reward grants) → refetch the chain so the claimed
    // tile flips to `collected` and the next package becomes `current` in place.
    async claimPackage(payPackage) {
      if (this.claiming) return;
      this.claiming = true;
      try {
        const claimResult = await claimFreePackage(payPackage.id);

        // Full-screen reward animation overlays the open modal. Wait for it to
        // finish BEFORE refetching the chain — the refetch updates the layout
        // data, which triggers the scroll-to-current transition. Sequencing
        // them stops the tiles from sliding while the reward is still playing.
        // Prefer the claim response's granted assets (random cards carry their
        // real id there); fall back to the package's declared assets.
        const grantedAssets = this.extractClaimedAssets(claimResult);
        const rewards = this.buildRewardAnimationArray(
          grantedAssets.length ? grantedAssets : payPackage.assets
        );
        if (rewards.length) {
          this.AnimationFullRewardEarnedAnimate(rewards, false);
          await this.waitForRewardAnimation();
        }

        this.$store.commit("shop/setOfferChainUnlockAnim", true);

        const active = await this.$store.dispatch("shop/fetchOfferChain");
        const id = this.offerData && this.offerData.id;
        const stillActive =
          Array.isArray(active) && active.some((c) => c && c.id === id);
        if (stillActive) {
          this.$store.commit("shop/setShowOfferChainModal", true);
        } else {
          // Last package collected → chain complete. Close the modal; the stale
          // selection is cleared on @hidden (after the hide transition) to avoid
          // tearing the open modal out of the DOM mid-transition.
          this.$store.commit("shop/setOfferChainUnlockAnim", false);
          this.closeModal();
        }
        this.$store.dispatch("user/updateUser");
      } catch (error) {
        console.error("[OfferChain] claim failed:", error);
        this.displayErrorMessage();
      } finally {
        this.claiming = false;
      }
    },
    // Resolve once the reward-earned animation queue has finished. The queue
    // sets `popups/queueAnimationIsRunning` true while playing and false when
    // done (see animation-base-functions). Wait for the running→idle edge; a
    // timeout fallback covers the case where the animation never starts (e.g.
    // runningAllowed() is false) so the chain still advances.
    waitForRewardAnimation() {
      return new Promise((resolve) => {
        const getRunning = () =>
          this.$store.getters["popups/getQueueAnimationIsRunning"];
        let started = getRunning();
        let done = false;
        const finish = () => {
          if (done) return;
          done = true;
          unwatch();
          clearTimeout(fallback);
          resolve();
        };
        const unwatch = this.$store.watch(getRunning, (running) => {
          if (running) started = true;
          else if (started) finish();
        });
        // Fallback: if it hasn't started within 1.5s, stop waiting.
        const fallback = setTimeout(() => {
          if (!started) finish();
        }, 1500);
      });
    },
  },
};
